var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video-section",on:{"click":function($event){return _vm.$modal.show('video-modal')}}},[_c('img',{attrs:{"src":"/images/stream-dreams/backgrounds/fuslie.jpg","alt":"Fuslie"}})])}
var staticRenderFns = []

export { render, staticRenderFns }